import React from "react";
import { TableCell, TableRow } from "@mui/material";

import BoxGrid from "../boxGrid/boxGrid";
import KogCheckbox from "../checkbox/kogCheckbox";
import { KeyValue } from "@/main/models/common";
import { Controller, useFieldArray, useFormContext } from "react-hook-form";
import { ISupplyCongigFormSave } from "../supplyConfig/supplyConfigRegister";
import * as S from "./styles";

interface IOptionElement {
	content: string | React.ReactNode;
	width?: string | number;
}
export type IOptionGridCheckbox = {
	guid: string;
	elements: IOptionElement[];
};

interface IKOGSupplyConfigBoxGridMultiCheckboxProps {
	rowHeaders: string[] | React.ReactNode[];
	sizeColumnTypes: string;
	dataSupplierTypes: KeyValue[];
	isStickHeader?: boolean;
}

function KOGSupplyConfigBoxGridMultiCheckbox({
	rowHeaders,
	sizeColumnTypes,
	dataSupplierTypes,
	isStickHeader = true,
}: IKOGSupplyConfigBoxGridMultiCheckboxProps) {
	const { control, getValues, setValue } = useFormContext<ISupplyCongigFormSave>();
	const { fields } = useFieldArray({
		control,
		name: "vehicles",
	});

	function handleToggleSelect(idSupplierType: number, _checked: boolean) {
		const formValues = getValues();
		const selectAll = formValues.selectAllSupplierType.find((item) => item.idSupplierType === idSupplierType);
		if (!selectAll) return;

		const onlySelected = formValues.vehicles.filter((item) =>
			item.supplierTypes.some((supplierType) => supplierType.idSupplierType === idSupplierType && supplierType.isCheck),
		);
		const isAllSelected = onlySelected.length === formValues.vehicles.length;
		if (isAllSelected && !selectAll.isCheck) {
			const indexSelectAll = formValues.selectAllSupplierType.findIndex(
				(item) => item.idSupplierType === idSupplierType,
			);
			setValue(`selectAllSupplierType.${indexSelectAll}.isCheck`, true);
		}

		if (!isAllSelected && selectAll.isCheck) {
			const indexSelectAll = formValues.selectAllSupplierType.findIndex(
				(item) => item.idSupplierType === idSupplierType,
			);
			setValue(`selectAllSupplierType.${indexSelectAll}.isCheck`, false);
		}
	}
	function handleToggleSelectAll(indexSupplierType: number, checked: boolean) {
		fields.forEach((item, index) => {
			setValue(`vehicles.${index}.supplierTypes.${indexSupplierType}.isCheck`, checked);
		});
	}

	const rowHeadersSupplierTypes = dataSupplierTypes.map((supplierType, index) => (
		<S.ContainerHeaderGrid key={index}>
			<S.TitleType>{supplierType.value}</S.TitleType>
			<Controller
				control={control}
				name={`selectAllSupplierType.${index}.isCheck`}
				render={({ field: fieldController }) => (
					<KogCheckbox
						{...fieldController}
						checked={fieldController.value}
						onChange={(event, checked) => {
							handleToggleSelectAll(index, checked);
							fieldController.onChange(!fieldController.value);
						}}
						id={`id-registerSupplier-checkbox-selectAll${supplierType.value}`}
					/>
				)}
			/>
		</S.ContainerHeaderGrid>
	));
	const rowHeadersFormatted = [...rowHeaders, ...rowHeadersSupplierTypes];

	const propsTable =
		isStickHeader === true
			? {
					stickyHeader: true,
				}
			: {};

	return (
		<BoxGrid rowHeaders={rowHeadersFormatted} propsTable={propsTable} typeGrid="default" sizeCell="small">
			{fields.map((field, index) => (
				<TableRow key={field.id}>
					<TableCell style={{ paddingLeft: 10 }}>{field.nameVehicleManufacturer}</TableCell>
					{field.supplierTypes.map((supplierType, indexSupp) => (
						<TableCell
							key={supplierType.idSupplierType}
							width={sizeColumnTypes}
							align="center"
							style={{ paddingRight: 10 }}
						>
							<Controller
								control={control}
								name={`vehicles.${index}.supplierTypes.${indexSupp}.isCheck`}
								render={({ field: fieldController }) => (
									<KogCheckbox
										{...fieldController}
										onChange={(event, checked) => {
											fieldController.onChange(checked);
											handleToggleSelect(supplierType.idSupplierType, checked);
										}}
										checked={fieldController.value}
										id={`id-registerSupplier-checkbox-${supplierType.idSupplierType}-${field.nameVehicleManufacturer}`}
									/>
								)}
							/>
						</TableCell>
					))}
				</TableRow>
			))}
		</BoxGrid>
	);
}

export default KOGSupplyConfigBoxGridMultiCheckbox;
